import { ref } from 'vue'

const overlay = ref(false)

export default function() {
	return {
		overlay
	}
}